import React, {PureComponent} from "react"
import {Mutation} from "@irati/utils/services/apollo"
import {MutationProps, ApolloQueryResult} from "@irati/utils/apollo"
import {Recognition} from "@irati/types"

const graphQLMutation = gql`
  mutation updateRecognition($recognitionId: String!, $message: String!) {
    updateRecognition(recognitionId: $recognitionId, message: $message) {
      uuid
      message
    }
  }
`

interface Props extends Partial<MutationProps> {
  recognition: Recognition
  newMessage: string
  children: any
}

interface Data {
  data: {
    updateRecognition: Recognition
  }
}

export default class UpdateRecognitionMutation extends PureComponent<Props> {
  render() {
    const {recognition, newMessage, children, ...props} = this.props
    return (
      <Mutation mutation={graphQLMutation} {...props}>
        {(mutate: any, apolloState: ApolloQueryResult<Data>) =>
          children(
            () =>
              mutate({
                variables: {
                  recognitionId: recognition.uuid,
                  message: newMessage
                }
              }),
            apolloState
          )
        }
      </Mutation>
    )
  }
}
import {gql} from "@irati/utils/gql"
